import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const ConfirmationDialog = ({
    title='Confirmation',
    text='Please press confirm to continue, or cancel to go back!',
    operation='Confirm', 
    variant='success',
    show=false,
    setShow,
    onConfirm=() => {}
}) => {
    const handleClose = () => setShow(false);
    const confirm = (...params) => {
        setShow(false);
        onConfirm(...params);
    }
    return (
        <div className='dialog-root'>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{text}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary raised-button" onClick={handleClose}>Cancel</Button>
                    <Button variant={`${variant} raised-button`} onClick={confirm}>{operation}</Button>
                </Modal.Footer>
            </Modal>
        </div>
        
    );
}

export default ConfirmationDialog;